
import CalendarField from '../../components/CalendarField/CalendarField';
import EmploymentSubtitle from '../../components/EmploymentSubtitle/EmploymentSubtitle';
import OccupationField from '../../components/OccupationField/OccupationField';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import SectorField from '../../components/SectorField/SectorField';
import ShowDetailsModal from '../../components/ShowDetailsModal/ShowDetailsModal';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import { useAppSelector } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { selectFieldValue } from '../../store/applicationform/applicationFormSelectors';
import { WizardPageAction } from '../../store/wizard/wizard';

const EmploymentPageSE = () => {
    useComponentTracker('EmploymentPage');

    const translate = useTranslation();
    const { totalSections, totalAboutYouPages } = usePagesConfig();
    const { currentPage } = usePagesContext();

    const employmentType = useAppSelector(selectFieldValue)('applicantEmploymentType');
    const sectorType = useAppSelector(selectFieldValue)('applicantEmploymentTypeSector');
    const employmentDate = useAppSelector(selectFieldValue)('applicantEmployedSince');

    const defaultPagesAction = useDefaultPagesAction();
    const validationErrors = useValidation(['applicantEmploymentType']);

    const onAction = async (action: WizardPageAction) => {
        if (action === 'next') {
            if (validationErrors.length) {
                return false;
            }

            if (
                !employmentType ||
                !employmentDate ||
                ((employmentType === 'EMPLOYEE' ||
                    employmentType === 'SUBSTITUTE' ||
                    employmentType === 'SELF_EMPLOYED') &&
                    !sectorType)
            ) {
                return false;
            }
        }

        return defaultPagesAction(action);
    };

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={onAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.employment.title')} />
            <ShowDetailsModal
                label={translate('dialog.know-more.label')}
                dialogTitle={translate('dialog.know-more.label')}
                dialogContent={translate('page.employment.dialog.content')}
            />
            <OccupationField
                label={translate('field.applicant-employment-type.label')}
                name={'applicantEmploymentType'}
            />
            {employmentType === 'EMPLOYEE' || employmentType === 'SUBSTITUTE' || employmentType === 'SELF_EMPLOYED' ? (
                <SectorField
                    label={translate('field.applicant-sector-type.label')}
                    name={'applicantEmploymentTypeSector'}
                />
            ) : null}
            <EmploymentSubtitle employmentType={employmentType as string} />
            {employmentType && <CalendarField name={'applicantEmployedSince'} />}

            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};
export default EmploymentPageSE;
